import { makeStyles, Theme, createStyles, withStyles } from '@material-ui/core/styles';
import { blue, orange, pink, red } from '@material-ui/core/colors';
import { InputBase } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  header: {
    padding: `${theme.spacing(1.75)}px ${theme.spacing(3)}px`,
  },
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(2),
  },

  box: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // marginBottom: theme.spacing(3),
    flexWrap: 'wrap',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },

  filters: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    flex: 1,

    [theme.breakpoints.down('md')]: {
      width: '100%',
    },

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },

  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),

    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: theme.spacing(2),
      justifyContent: 'space-between',
    },

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },

  paper: {
    padding: theme.spacing(3),
    margin: theme.spacing(2, 0),
    boxShadow: theme.shadows[1],
  },
  scanButton: {
    backgroundColor: '#1976d2',
    color: 'white',
    padding: theme.spacing(1.5, 3),
    borderRadius: theme.spacing(1),
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#1565c0',
    },
    '&:disabled': {
      backgroundColor: '#ccc',
      cursor: 'not-allowed',
    },
  },
  progressContainer: {
    margin: theme.spacing(2, 0),
  },
  progressBar: {
    width: '100%',
    height: '8px',
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#1976d2',
    transition: 'width 0.3s ease',
  },
  filtersContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: theme.spacing(2),
    margin: theme.spacing(3, 0),
  },
  filterSelect: {
    padding: theme.spacing(1.5),
    border: '1px solid #ddd',
    borderRadius: theme.spacing(1),
    fontSize: '14px',
    backgroundColor: 'white',
  },
  applyButton: {
    backgroundColor: '#5081FF',
    color: 'white',
    padding: theme.spacing(1.5, 3),
    borderRadius: theme.spacing(1),
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 500,
    marginTop: '11px',
    marginBottom: theme.spacing(2),
    '&:hover': {
      backgroundColor: '#5081FF',
    },
  },
  resultsContainer: {
    marginTop: theme.spacing(3),
  },
  resultHeader: {
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: '#333',
  },
  riskCard: {
    border: '1px solid #e0e0e0',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: '#fafafa',
  },
  riskHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1),
  },
  severityBadge: {
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(0.5),
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  criticalSeverity: {
    backgroundColor: '#ffebee',
    color: '#c62828',
  },
  highSeverity: {
    backgroundColor: '#fff3e0',
    color: '#ef6c00',
  },
  mediumSeverity: {
    backgroundColor: '#fffde7',
    color: '#f57f17',
  },
  lowSeverity: {
    backgroundColor: '#e3f2fd',
    color: '#1976d2',
  },
  riskType: {
    fontSize: '12px',
    color: '#666',
    marginLeft: theme.spacing(1),
  },
  provider: {
    fontSize: '12px',
    color: '#999',
  },
  description: {
    marginTop: theme.spacing(1),
    color: '#555',
    lineHeight: 1.4,
  },
  timestamp: {
    fontSize: '11px',
    color: '#999',
    marginTop: theme.spacing(1),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(4),
  },
  noResults: {
    textAlign: 'center',
    padding: theme.spacing(4),
    color: '#666',
    fontSize: '16px',
  },

  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'space-between',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      gap: theme.spacing(1),
    },
  },
  summaryCard: {
    // padding: theme.spacing(3),
    textAlign: 'center',
    marginBottom: theme.spacing(2),
    // borderRadius: theme.spacing(2),
    background: 'linear-gradient(135deg, #ffffff 0%, #f8faff 100%)',
    // border: '1px solid rgba(0,0,0,0.08)',
    transition: 'all 0.3s ease',
    // '&:hover': {
    //   transform: 'translateY(-4px)',
    //   boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
    //   border: '1px solid rgba(80,129,255,0.3)',
    // },
  },
  managerHeader: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    borderRadius: theme.spacing(1),
  },

  summaryGrid: {
    marginBottom: theme.spacing(2),
  },
  statsCard: {
    borderRadius: theme.spacing(1),
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    height: '100%',
  },
  statsLabel: {
    color: theme.palette.text.secondary,
    fontSize: 13,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  statsValue: {
    color: theme.palette.text.primary,
    fontSize: 28,
    fontWeight: 700,
    lineHeight: 1.2,
    marginTop: theme.spacing(1),
  },
  reportRange: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  dataGrid: {
    width: '100%',
    '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
    '& .MuiDataGrid-root .MuiDataGrid-row': {
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .row-background-error': {
      backgroundColor: red[50],
      '&:hover': {
        backgroundColor: red[100],
      },
    },
    '& .row-background-alert': {
      backgroundColor: pink[50],
      '&:hover': {
        backgroundColor: pink[100],
      },
    },
    '& .row-background-transaction': {
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .cell-text-color-error': {
      color: pink[700],
    },
    '& .cell-text-color-alert': {
      color: orange[700],
    },
    '& .cell-text-color-transaction': {
      color: 'black',
      fontWeight: '500',
      textTransform: 'capitalize',
    },
    '& .MuiDataGrid-colCellTitle': {
      color: 'black',
      fontWeight: '700',
      textTransform: 'capitalize',
    },
  },
  // dataGrid: {
  //   marginTop: theme.spacing(2),
  //   '& .MuiDataGrid-root': {
  //     border: 'none',
  //   },
  //   '& .MuiDataGrid-cell': {
  //     borderBottom: 'none',
  //   },
  //   '& .MuiDataGrid-columnHeaders': {
  //     borderBottom: 'none',
  //     backgroundColor: theme.palette.grey[50],
  //   },
  //   '& .MuiDataGrid-virtualScroller': {
  //     backgroundColor: theme.palette.background.paper,
  //   },
  // },
  // noBorder: {
  //   border: 'none',
  // },
  chip: {
    margin: theme.spacing(0.5),
  },
  reportSection: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  icon: {
    fontSize: '2.5rem',
    color: '#5081FF',
    marginBottom: theme.spacing(1),
  },
  // box: {
  //   marginBottom: theme.spacing(2),
  // },
  // link: {
  //   color: theme.palette.primary.main,
  //   cursor: 'pointer',
  //   textDecoration: 'underline',
  //   '&:hover': {
  //     textDecoration: 'none',
  //   },
  // },
  title: {
    flexGrow: 1,
    margin: theme.spacing(1),
  },
  link: {
    cursor: 'pointer',
    marginRight: '5px',
    color: 'blue',
  },
  // content: {
  //   flexGrow: 1,
  //   height: '100vh',
  //   overflow: 'auto',
  //   marginTop: theme.spacing(6),
  // },
  // container: {
  //   paddingTop: theme.spacing(4),
  //   paddingBottom: theme.spacing(4),
  // },
  // paper: {
  //   padding: theme.spacing(2),
  //   display: 'flex',
  //   overflow: 'auto',
  //   flexDirection: 'column',
  // },
  //   paper: {
  //   padding: theme.spacing(3),
  //   borderRadius: theme.spacing(1),
  //   boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  // },
  fixedHeight: {
    height: 240,
  },
  logo: {
    margin: theme.spacing(2),
  },
  infoContainer: {
    disply: 'flex',
    marginBottom: theme.spacing(1),
    height: '25%',
  },
  infoBar: {
    width: '30%',
    height: '100%',
  },
  margin: {
    margin: theme.spacing(1),
  },
  // applyButton: {
  //   width: 142,
  //   borderRadius: '0 4px 4px 0',
  //   height: 50,
  //   color: theme.palette.background.paper,
  //   fontSize: 14,
  //   textTransform: 'none',
  //   boxShadow: 'none',
  //   marginRight: theme.spacing(1),
  //   backgroundColor: green[500],
  //   '&:hover': {
  //     backgroundColor: green[700],
  //   },
  // },
  select: {
    margin: theme.spacing(1),
    //width: '30%',
  },
  addNewButton: {
    height: 50,
    fontSize: 14,
    textTransform: 'none',
    boxShadow: 'none',
    //margin: theme.spacing(1),
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: '#5081FF',
    '&:hover': {
      backgroundColor: blue[700],
    },
  },
  // box: {
  //   marginBottom: theme.spacing(3),
  // },
  headerBtn: {
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
    height: 50,
  },
  noBorder: {
    border: 'none',
  },
  // dataGrid: {
  //   width: '100%',
  //   '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
  //   '& .MuiDataGrid-root .MuiDataGrid-row': {
  //     '&:hover': {
  //       backgroundColor: 'rgba(255, 80, 95, 0.04)',
  //     },
  //   },
  //   '& .row-background-error': {
  //     backgroundColor: red[50],
  //     '&:hover': {
  //       backgroundColor: red[100],
  //     },
  //   },
  //   '& .row-background-alert': {
  //     backgroundColor: pink[50],
  //     '&:hover': {
  //       backgroundColor: pink[100],
  //     },
  //   },
  //   '& .row-background-transaction': {
  //     backgroundColor: 'white',
  //     '&:hover': {
  //       backgroundColor: 'rgba(255, 80, 95, 0.04)',
  //     },
  //   },
  //   '& .cell-text-color-error': {
  //     color: pink[700],
  //   },
  //   '& .cell-text-color-alert': {
  //     color: orange[700],
  //   },
  //   '& .cell-text-color-transaction': {
  //     color: 'black',
  //     fontWeight: '500',
  //     textTransform: 'capitalize',
  //   },
  //   '& .MuiDataGrid-colCellTitle': {
  //     color: 'black',
  //     fontWeight: '700',
  //     textTransform: 'capitalize',
  //   },
  // },
}));

export const useStylesSecond = makeStyles((theme: Theme) => ({
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 14,
  },

  sync: {
    display: 'flex',
    justifyContent: 'center',
    justifyItems: 'center',
    flexGrow: 1,
    margin: theme.spacing(1),
    color: 'red',
    padding: theme.spacing(1),
  },

  title: {
    flexGrow: 1,
    fontSize: 14,
    margin: theme.spacing(1),
  },
  gridPaper: {
    height: '100%',
  },
  tabsPaper: {
    width: '100%',
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
    '& [class*="MuiBox-root"]': {
      padding: theme.spacing(2, 0, 0, 0),
    },
  },
  tabsPanel: {
    padding: 12,
    width: '100%',
  },
  tabBox: {
    //backgroundColor: '#ffffff',
    //marginTop: theme.spacing(2.5),
  },
  tab: {
    //backgroundColor: '#ffffff',
    marginTop: theme.spacing(2.5),
  },
  container: {
    width: '100%',
  },
  row: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(3.5),
  },
  box: {
    marginBottom: theme.spacing(2),
    width: '100%',
    display: 'flex',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titlePopSmtp: {
    width: 170,
    margin: theme.spacing(0, 5, 0, 0),
    color: 'rgb(0 0 0 / 87%)',
  },
  select: {
    margin: theme.spacing(1),
    '& .MuiSelect-select:focus': {
      background: '#fff',
    },
  },
  desc: {
    width: 320,
    borderBottom: '1px solid #E0E0E0',
    padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  tabs: {
    width: 'fit-content',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
  },
  badge: {
    position: 'relative',
    left: theme.spacing(-2),
  },
}));
export const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(0.5, 0),
      },
    },

    input: {
      width: '200px',
      padding: '16px 16px',
      marginLeft: theme.spacing(1),
      borderRadius: 4,
      position: 'relative',
      background: '#fff',
      fontSize: 14,
      [theme.breakpoints.down('md')]: {
        width: '180px',
        padding: '14px 12px',
        fontSize: 13,
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginLeft: 0,
        padding: '12px 10px',
        fontSize: 12,
      },
      [theme.breakpoints.down('xs')]: {
        padding: '10px 8px',
        fontSize: 11,
      },
    },
  })
)(InputBase);
